import { gql } from '@apollo/client';

export const FETCH_OPTIMIZER_AUDITS_V2 = gql`
  query fetchOptimizerAuditsV2($input: FetchOptimizerAuditsV2Input!) {
    fetchOptimizerAuditsV2(input: $input) {
      audits {
        id
        portfolioReportId
        passed
        validationErrors
        durationMs
        rebalanceMode
        effectiveRebalanceMode
        solver {
          status
          durationMs
        }
        targetWeights {
          financialProductId
          targetWeight
        }
        subAccountResults {
          subAccountId
          accountType
          inputMarketValueCents
          inputCashCents
          tradeCount
          totalBuyCents
          totalSellCents
          weightDiffs {
            financialProductId
            currentWeight
            proposedWeight
            deltaWeight
            deltaCents
            inputQuantity
            inputPositionValueCents
            inputAdjustedCostBaseCents
          }
        }
        decisions {
          stage
          action
          impact
        }
      }
    }
  }
`;
